<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isShowDiscountUseAudit ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" before-btns>
    <!-- audit menu btn -->
    <a
      *ngIf="userSession?.isSuperAdmin()"
      [matMenuTriggerFor]="menu"
      class="btn btn-light txt-lg button-shadow tw-mx-1"
      type="button"
      mat-ripple
      [matTooltip]="'pages.audits.title' | translate"
    >
      <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
    </a>
    <mat-menu #menu="matMenu" xPosition="after">
      <!-- discount audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowAuditPage()"
      >
        <span class="tw-mx-1">{{ pageVocabs + "title" | translate }}</span>
      </a>

      <!-- discount use audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowDiscountUseAuditPage()"
      >
        <span class="tw-mx-1">{{
          pageVocabs + "discountUse" | translate
        }}</span>
      </a>
    </mat-menu>
  </div>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- discountCode -->
        <td>
          <td-value copyToClipboard [value]="item?.discountCode"></td-value>
        </td>

        <!-- discountType -->
        <td>
          <span copyToClipboard>{{
            item?.discountType | enumToText : DiscountTypeValues
          }}</span>
        </td>

        <!-- isPercentage -->
        <td>
          <td-value type="boolean" [value]="item?.isPercentage"></td-value>
        </td>

        <!-- discountValue -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.discountValue"
          ></td-value>
          <span *ngIf="item?.isPercentage">%</span>
          <span *ngIf="!item?.isPercentage" class="tw-px-1">{{
            "common.currency" | translate
          }}</span>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- specialOrganizationName -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.specialOrganizationName"
          ></td-value>
        </td>

        <!-- maximumAmount -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.maximumAmount"
          ></td-value>
        </td>

        <!-- maximumUse -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.maximumUse"
          ></td-value>
        </td>

        <!-- dateStart -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.dateStart"
          ></td-value>
        </td>

        <!-- dateExpire -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.dateExpire"
          ></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete(item.id, item.discountCode)"
            (onUpdate)="onUpdate(item?.id)"
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-discount-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-discount-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--discount use audits-->
<ng-container *ngIf="isShowDiscountUseAudit">
  <app-audit
    [service]="currentService"
    [methodName]="useAuditApiMethodName"
    (hidePage)="isShowDiscountUseAudit = false"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
